import type { Sort, Attribute } from 'stores/PaginationTypes';
import { commonEventAttributes, eventsTableSpecificAttributes } from 'components/events/Constants';
import { SECURITY_EVENT_STATUSES } from 'security-app/hooks/api/securityEventsAPI.types';
import OwnerFilter from 'security-app/components/SecurityEvents/Alerts/OwnerFilter';
import TacticTechniqueFilter from 'security-app/components/SecurityEvents/Alerts/MitreCategories/TacticTechniqueFilter';
import EventDefinitionTypeFilter from 'security-app/components/SecurityEvents/Alerts/EventDefinitionTypeFilter';

export const SECURITY_EVENTS_ENTITY_TABLE_ID = 'security_events';

export const securityEventDetailsAttributes: Array<Attribute> = [
  ...commonEventAttributes,
  {
    id: 'status',
    title: 'Status',
    type: 'STRING',
    filterable: true,
    filter_options: Object.entries(SECURITY_EVENT_STATUSES).map(([value, title]) => ({ value, title })),
  },
  {
    id: 'scores',
    title: 'Risk Score',
    type: 'STRING',
    sortable: true,
  },
  {
    id: 'event_id',
    title: 'ID',
    type: 'STRING',
    sortable: true,
  },
  {
    id: 'associated_investigations',
    title: 'Associated Investigations',
    type: 'OBJECT_ID',
  },
  {
    id: 'fields',
    title: 'Additional Fields',
    sortable: false,
  },
];

export const categoryKey = 'category';
export const attributes: Array<Attribute> = [
  ...securityEventDetailsAttributes.filter((type) => type.id !== 'event_definition_type'),
  ...eventsTableSpecificAttributes,
  {
    id: 'owner',
    title: 'Owner',
    type: 'STRING',
    filterable: true,
    filter_component: OwnerFilter,
  },
  {
    id: 'event_definition_type',
    title: 'Event Definition Type',
    type: 'STRING',
    filterable: true,
    filter_component: EventDefinitionTypeFilter,
  },
  {
    id: categoryKey,
    title: 'Tactic/Technique',
    type: 'STRING',
    filterable: true,
    filter_component: TacticTechniqueFilter,
  },
];

export const securityEventsTableElements = {
  defaultLayout: {
    entityTableId: SECURITY_EVENTS_ENTITY_TABLE_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: 'timestamp', direction: 'desc' } as Sort,
    defaultDisplayedAttributes: ['message', 'scores', 'owner', 'alert', 'status', 'timestamp'],
  },
  columnOrder: [
    'message',
    'scores',
    categoryKey,
    'owner',
    'alert',
    'status',
    'priority',
    'timestamp',
    'key',
    'event_definition_id',
    'event_definition_type',
    'group_by_fields',
    'remediation_steps',
    'event_id',
    'associated_investigations',
  ],
};
